<template>
  <div>
    <el-table
      ref="singleTable"
      :data="
        priceData.filter((data) =>
          store ? (store === 'all' ? data : data.store === store) : data
        )
      "
      highlight-current-row
      style="
         {
          overflow-x: scroll;
          width: 950px;
          margin: 0 auto;
        }
      "
    >
      <el-table-column type="index" width="50"> </el-table-column>
      <el-table-column width="150" property="store" label="Store">
        <template slot-scope="scope">
          <span>{{
            $store.state.stores.find((store) => store.id == scope.row.store)
              .name
          }}</span></template
        >
      </el-table-column>
      <el-table-column width="150" property="serial" label="Serial/Item Code">
        <template slot-scope="scope">
          <el-input
            size="mini"
            v-model="scope.row.serial"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column width="150" property="purcPr" label="Purchased Price">
        <template slot-scope="scope">
          <el-input-number
            size="mini"
            :precision="2"
            :min="0"
            v-model="scope.row.purcPr"
            @change="setRowSellPr(scope)"
          ></el-input-number>
        </template>
      </el-table-column>
      <el-table-column width="150" property="sellPr" label="Selling Price">
        <template slot-scope="scope">
          <el-input-number
            size="mini"
            :precision="2"
            :min="0"
            v-model="scope.row.sellPr"
          ></el-input-number>
        </template>
      </el-table-column>
      <el-table-column width="150" property="quantity" label="Quantity">
        <template slot-scope="scope">
          <el-input-number
            size="mini"
            :precision="2"
            :min="0"
            v-model="scope.row.quantity"
          ></el-input-number>
        </template>
      </el-table-column>
      <el-table-column width="150" label="Operations">
        <template slot-scope="scope">
          <el-button
            size="small"
            @click="open(scope.$index, scope.row)"
            type="danger"
            icon="el-icon-delete"
            circle
          ></el-button>
          <a
            v-if="printMethod"
            size="sm"
            @click="print(product,scope.row)"
            class="btn btn-sm btn-secondary text-white"
          >
            Print Labels
          </a>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 10px; height: 30px">
      <!-- <el-button plain @click="showPriceTable = false">Close</el-button> -->
      <el-select
        style="float: right; width: 160px; margin-right: 0px"
        label="Select Store"
        v-model="store"
        size="small"
        placeholder="Select Store"
        @change="updatePriceData"
      >
        <el-option
          v-for="item in stores"
          :key="item.value"
          :label="item.label"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-button
        size="small"
        style="float: right; margin-right: 20px"
        v-if="store && store !== 'all'"
        plain
        @click="addRow()"
        >Add Price Row</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "priceTable",
  props: ["priceData", "showPriceTable","printMethod","product", 'profitMargin'],
  data() {
    return {
      currentRow: null,
      store: 'all', //this.$store.state.selectedStore,
      tableData: [],
      stores: [
        { id: "all", value: "all", label: "All Stores" },
        ...this.$store.state.stores,
      ],
    };
  },
  created() {
    this.tableData = this.priceData;
    console.log("profitMargin",this.profitMargin)
  },

  methods: {
    print(product,item) {
      this.printMethod(product,item)
    },
    updatePriceData(store) {
      // this.tableData = this.priceData;
      // this.tableData = this.tableData.filter((data) => data.store === store);
      console.log(this.priceData, this.tableData);
    },

    setRowSellPr(scope) {
      scope.row.sellPr = (this.profitMargin && scope.row.purcPr) ? (scope.row.purcPr + (scope.row.purcPr * this.profitMargin / 100)) : scope.row.sellPr
    },

    addRow() {
      this.priceData.push({
        purcPr: 0,
        sellPr: 0,
        quantity: 0,
        serial: '',
        store: this.store,
      });
      console.log(this.priceData, this.tableData);
    },
    handleDelete(index, row) {
      const foundIndex = this.priceData.findIndex(
        (pr) =>
          pr.store === row.store &&
          pr.sellPr === row.sellPr &&
          pr.purcPr === row.purcPr &&
          pr.serial === row.serial &&
          pr.quantity === row.quantity
      );
      this.priceData.splice(foundIndex, 1);
      console.log(this.priceData, this.tableData);
    },
    open(index, row) {
      this.$confirm(
        "This will permanently delete the item. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.handleDelete(index, row);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/admin/PriceTable.vue